<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="value") {{ gameName }}
        game-preview-setting(v-if="parameters.withTime")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_showTime') }}
            span(slot="value") {{ parameters.showTime }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_minutes') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfRows') }}
            span(slot="value") {{ parameters.amountOfRows }}
        game-preview-setting
            span(slot="name" :style="{'text-overflow': 'inherit', 'white-space': 'normal'}") {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfElementsToRemember') }}
            span(slot="value") {{ parameters.amountOfItems }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('support.support_createTicket_theme') }}
            span(slot="value") {{ $i18n.tc('trainer.trainer_gameFormSetting_' + parameters.selectedTheme.theme, 1) }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
        computed: {
            gameName () {
                this.$i18n.t('common.common_gameName_correctiveSamples');
            },
        }
    }
</script>
